module.exports = __webpack_public_path__ + "img/ladrillos.0f85a3a4.png";